<template>
  <div class="products-list" :style="!this.isMobile && backgroundImg">
    <div class="container">
      <div class="content">
        <h2>{{ products.title }}</h2>
        <p v-html="products.description"></p>
        <ul>
          <li v-for="product in this.productsList" :class="{'item-link': product.link}" :key="product.id">
            <Link :href="product.link" v-if="product.link">{{ product.title }}</Link>
            <span v-else>{{ product.title }}</span>
          </li>
          <div :class="more ? 'load-more-block' : 'd-none'" />
        </ul>
        <div class="d-md-flex justify-content-md-center">
          <ButtonBlue :class="more ? 'w-100 mb-3' : 'd-none'" @click="loadMore" text="Load more" />
          <ButtonRed v-if="products.button.text && products.button.link" :text="products.button.text" hyperlink :href="products.button.link" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Background from '@/assets/images/UniqueOpening.jpg'
import ButtonRed from "@/components/common/ButtonRed";
import ButtonBlue from '@/components/common/ButtonBlue.vue';
import Link from "@/components/common/Link";
export default {
  components: {Link, ButtonRed, ButtonBlue },
  data(){
    return {
      bgImg: Background,
      productsList: [],
      more: false,
      isMobile: false,
    }
  },
  props: {
    products: {
      title: String,
      description: HTMLElement,
      bgImg: String,
      list: Array,
      button: {
        link: String,
        text: String
      }
    }
  },
  methods: {
    showProducts(count) {
      if (this.isMobile) {
        if (this.$props.products.list.length > count) {
        this.more = true;
      }

        this.productsList = this.$props.products.list.slice(0, count);
      } else {
        this.productsList = this.$props.products.list;
      }
    },
    loadMore() {
      this.more = false;
      this.productsList = this.$props.products.list;
    }
  },
  mounted() {
    this.isMobile = window.visualViewport.width < 576;
    this.showProducts(15);
    },
  computed: {
    backgroundImg() {
          return `background-image: url("${this.products.bgImg}");`;
      }
  }
}
</script>
